import { DecimalPipe } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';

/**
 * Decimal formatting pipe.
 *
 * - Defaults to `1.2-2` if no decimals provided
 * - Accepts number (fixed decimals) or string (custom format)
 *
 * Usage:
 * {{ amount | decimal }}
 * {{ amount | decimal: 4 }}
 * {{ amount | decimal: '1.0-6' }}
 */

@Pipe({
  name: 'decimal',
})
export class IwDecimalPipe extends DecimalPipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) locale: string) {
    super(locale);
  }

  override transform(
    value: number | string,
    digitsInfo?: string | number,
    locale?: string,
  ): any {
    if (typeof digitsInfo === 'string') {
      return super.transform(value, digitsInfo, locale);
    }

    const format = digitsInfo ? `1.${digitsInfo}-${digitsInfo}` : '1.2-2';
    return super.transform(value, format, locale);
  }
}
